import React from 'react'
import { DomainDto } from '../../../dtos/domain'
import { GetPromptGroupResponse } from '@pushly/models/lib/structs/prompts/get-prompt-group-response'
import { CreatePromptGroupRequest } from '@pushly/models/lib/structs/prompts/create-prompt-group-request'
import { UpdatePromptGroupRequest } from '@pushly/models/lib/structs/prompts/update-prompt-group-request'
import { PromptEditorTreatment } from './types'
import { DeliveryChannel } from '@pushly/models/lib/enums/delivery-channels.enum'

type BasePromptEditorContextState = {
    loading: boolean
    activeDeliveryChannels: DeliveryChannel[]
    selectedDeliveryChannel: DeliveryChannel
    isAutoShowEnabled: boolean
    isAbTestEnabled: boolean
}

export type PromptEditorContextLoadingState = BasePromptEditorContextState & {
    loading: true
    domain?: DomainDto
    promptGroupSource?: GetPromptGroupResponse
    promptGroup?: CreatePromptGroupRequest | UpdatePromptGroupRequest
    prompts?: PromptEditorTreatment[]
    selectedPrompt?: PromptEditorTreatment
    selectedPromptIdx?: number
    slidePromptImageUpload?: any
}

export type PromptEditorContextLoadedState = BasePromptEditorContextState & {
    loading: false
    domain: DomainDto
    promptGroupSource?: GetPromptGroupResponse
    promptGroup: CreatePromptGroupRequest | UpdatePromptGroupRequest
    prompts: PromptEditorTreatment[]
    selectedPrompt: PromptEditorTreatment
    selectedPromptIdx: number
    slidePromptImageUpload?: any
}

export type PromptEditorContextState = PromptEditorContextLoadingState | PromptEditorContextLoadedState

export const PromptEditorContext = React.createContext<PromptEditorContextState>(null!)
